module.exports = __webpack_public_path__ + "img/icons_12.0aa6b27a.svg";